// PRD.275 — Elia AI Assistant Drawer (Phase 1, UI only).
//
// Reusable incoming (Elia) / outgoing (user) chat bubble. Renders plain text
// from data only — no raw HTML. Long assistant messages collapse with a
// Show more / Show less toggle (FR-8, FR-15).

import { useState } from 'react';
import { ELIA_COLORS, ELIA_FONT } from './elia-theme';
import { EliaChevronIcon } from './EliaIcons';
import { ELIA_COLLAPSED_LINES, isCollapsibleAssistantContent } from './elia-message-utils';

export function EliaMessageBubble({
  role,
  content,
  collapsible = false,
}: {
  role: 'user' | 'assistant';
  content: string;
  collapsible?: boolean;
}) {
  const isUser = role === 'user';
  const canCollapse = collapsible && !isUser && isCollapsibleAssistantContent(content);
  const [expanded, setExpanded] = useState(false);
  const showClamp = canCollapse && !expanded;

  return (
    <div
      style={{
        maxWidth: '100%',
        background: isUser ? ELIA_COLORS.pink : ELIA_COLORS.neutralSurface,
        color: isUser ? '#ffffff' : ELIA_COLORS.text,
        padding: '12px 16px',
        borderRadius: isUser ? '16px 6px 16px 16px' : '16px 16px 16px 6px',
        fontFamily: ELIA_FONT,
        fontSize: 14,
        lineHeight: '22px',
        letterSpacing: '-0.15px',
      }}
    >
      <p
        style={{
          margin: 0,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          ...(showClamp
            ? {
                display: '-webkit-box',
                WebkitLineClamp: ELIA_COLLAPSED_LINES,
                WebkitBoxOrient: 'vertical' as const,
                overflow: 'hidden',
              }
            : {}),
        }}
      >
        {content}
      </p>
      {canCollapse ? (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          aria-expanded={expanded}
          style={{
            marginTop: 4,
            minHeight: 24,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            background: 'transparent',
            border: 'none',
            padding: '4px 0',
            cursor: 'pointer',
            color: ELIA_COLORS.pink,
            fontFamily: ELIA_FONT,
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          <EliaChevronIcon
            size={12}
            color={ELIA_COLORS.pink}
            direction={expanded ? 'up' : 'down'}
          />
          {expanded ? 'Show less' : 'Show more'}
        </button>
      ) : null}
    </div>
  );
}
